import React, { ReactNode } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

export type ClosingDateNoticeTone = 'info' | 'warning';

export interface ClosingDateNoticeProps {
    tone: ClosingDateNoticeTone;
    icon: IconDefinition;
    emphasised?: boolean;
    className?: string;
    children: ReactNode;
}

export const ClosingDateNotice = ({
    tone,
    icon,
    emphasised,
    className,
    children,
}: ClosingDateNoticeProps) => (
    <div
        className={[
            'closing-date-notice',
            `closing-date-notice--${tone}`,
            className,
        ]
            .filter(Boolean)
            .join(' ')}>
        <span
            className={[
                'closing-date-notice__badge',
                emphasised ? 'closing-date-notice__badge--emphasised' : '',
            ]
                .filter(Boolean)
                .join(' ')}>
            <FontAwesomeIcon icon={icon} />
        </span>
        <div className="closing-date-notice__content">{children}</div>
    </div>
);
